import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.news.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Location } from '@angular/common';
import showdown from 'showdown';

declare const WizRoute: any;

type LocalText = { ko: string; en: string };

@Component({
    selector: 'wiz-page-news-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.news.item/view.scss */
:host {
  display: block;
  background: #FFFFFF;
}

.news-detail-page {
  min-height: 60vh;
  background: #FFFFFF;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.news-detail-page h1,
.news-detail-page h2,
.news-detail-page h3,
.news-detail-page h4,
.news-detail-page p,
.news-detail-page span,
.news-detail-page button {
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.news-detail-hero {
  position: relative;
  min-height: 420px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  color: #FFFFFF;
  background: #11100F;
}

.detail-hero-image,
.detail-hero-bg,
.detail-hero-grid {
  position: absolute;
  inset: 0;
}

.detail-hero-image {
  background-position: center;
  background-size: cover;
  opacity: 0.36;
}

.detail-hero-bg {
  background: radial-gradient(circle at 82% 18%, rgba(254, 90, 51, 0.24), transparent 34%), linear-gradient(135deg, rgba(12, 10, 9, 0.92) 0%, rgba(24, 20, 19, 0.9) 58%, rgba(37, 24, 21, 0.92) 100%);
}

.detail-hero-grid {
  opacity: 0.32;
  background-image: linear-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.2), #000 36%, #000 80%, rgba(0, 0, 0, 0.18));
  -webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.2), #000 36%, #000 80%, rgba(0, 0, 0, 0.18));
}

.detail-hero-copy {
  max-width: 880px;
  padding: 86px 0 58px;
}
.detail-hero-copy h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 42px;
  font-weight: 800;
  line-height: 1.22;
  word-break: keep-all;
  overflow-wrap: normal;
}

.detail-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 700;
}

.detail-kicker-mark {
  width: 30px;
  height: 2px;
  border-radius: 1px;
  background: #FE5A33;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.detail-category {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 800;
}
.detail-category i {
  font-size: 16px;
  flex: 0 0 auto;
  line-height: 1;
}
.detail-category span {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
}
.detail-category.type-notice {
  background: #FFF5F2;
  color: #E04420;
}
.detail-category.type-article {
  background: #ECFDF5;
  color: #047857;
}
.detail-category.type-report {
  background: #F8FAFC;
  color: #475569;
}

.detail-date {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 800;
}

.detail-content {
  padding: 30px 0 88px;
  background: #FFFFFF;
}

.detail-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 860px;
  margin: 0 auto 34px;
}

.back-button,
.list-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #52525B;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.back-button i,
.list-button i {
  font-size: 16px;
}
.back-button:hover,
.list-button:hover {
  border-color: rgba(254, 90, 51, 0.42);
  background: #FFF5F2;
  color: #E04420;
}

.article-wrap {
  max-width: 860px;
  margin: 0 auto;
}

:host ::ng-deep .article-content {
  color: #3F3F46;
  font-size: 17px;
  line-height: 1.86;
}
:host ::ng-deep .article-content h1,
:host ::ng-deep .article-content h2,
:host ::ng-deep .article-content h3,
:host ::ng-deep .article-content h4,
:host ::ng-deep .article-content h5,
:host ::ng-deep .article-content h6 {
  margin: 2em 0 0.75em;
  color: #18181B;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0;
}
:host ::ng-deep .article-content h1 {
  font-size: 30px;
}
:host ::ng-deep .article-content h2 {
  font-size: 25px;
}
:host ::ng-deep .article-content h3 {
  font-size: 21px;
}
:host ::ng-deep .article-content p {
  margin: 0 0 1.3em;
  color: #3F3F46;
}
:host ::ng-deep .article-content strong {
  color: #18181B;
  font-weight: 800;
}
:host ::ng-deep .article-content ul,
:host ::ng-deep .article-content ol {
  margin: 0 0 1.4em;
  padding-left: 1.45em;
}
:host ::ng-deep .article-content li {
  margin-bottom: 0.55em;
}
:host ::ng-deep .article-content a {
  color: #E04420;
  text-decoration: underline;
  text-underline-offset: 3px;
}
:host ::ng-deep .article-content hr {
  margin: 32px 0;
  border: 0;
  border-top: 1px solid #E4E4E7;
}
:host ::ng-deep .article-content blockquote {
  margin: 1.6em 0;
  padding: 2px 0 2px 18px;
  border-left: 3px solid #FE5A33;
  color: #71717A;
}
:host ::ng-deep .article-content img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 28px auto;
  border-radius: 8px;
}
:host ::ng-deep .article-content table {
  width: 100%;
  margin: 28px 0;
  border-collapse: collapse;
  font-size: 16px;
}
:host ::ng-deep .article-content th,
:host ::ng-deep .article-content td {
  padding: 12px 14px;
  border: 1px solid #E4E4E7;
  text-align: left;
  vertical-align: top;
}
:host ::ng-deep .article-content th {
  background: #FAFAFA;
  color: #18181B;
  font-weight: 800;
}

.article-attachments {
  display: grid;
  gap: 8px;
  margin-top: 34px;
  padding-top: 22px;
  border-top: 1px solid #E4E4E7;
}

.article-attachment {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  width: fit-content;
  max-width: 100%;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #3F3F46;
  font-size: 16px;
  font-weight: 800;
  text-decoration: none;
}
.article-attachment i {
  color: #FE5A33;
  font-size: 16px;
}
.article-attachment span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #A1A1AA;
  text-align: center;
}
.empty-state i {
  margin-bottom: 14px;
  font-size: 42px;
  color: #D4D4D8;
}
.empty-state p {
  margin: 0 0 18px;
  font-size: 16px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .news-detail-hero {
    min-height: 340px;
  }
  .detail-hero-copy {
    padding: 58px 0 42px;
  }
  .detail-hero-copy h1 {
    font-size: 31px;
    line-height: 1.24;
  }
  .detail-toolbar {
    align-items: stretch;
    flex-direction: column;
    margin-bottom: 28px;
  }
  .back-button,
  .list-button {
    width: 100%;
  }
  :host ::ng-deep .article-content {
    font-size: 16px;
    line-height: 1.8;
  }
  :host ::ng-deep .article-content h1 {
    font-size: 26px;
  }
  :host ::ng-deep .article-content h2 {
    font-size: 22px;
  }
  :host ::ng-deep .article-content h3 {
    font-size: 19px;
  }
}`],
})
export class PageNewsItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Location)  public location: Location) { }

    public category: string = '';
    public post_id: string = '';
    public item: any = null;
    public loaded: boolean = false;
    public loadError = false;
    private converter = new showdown.Converter();

    public categories = [
        { key: 'notice', label: { ko: '공지사항', en: 'Notice' }, icon: 'icon-megaphone' },
        { key: 'article', label: { ko: '보도자료', en: 'Articles' }, icon: 'icon-newspaper' },
        { key: 'report', label: { ko: '보고서', en: 'Reports' }, icon: 'icon-file-text' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.category = WizRoute.segment.category;
        this.post_id = WizRoute.segment.id;
        await this.load();
    }

    public async load() {
        this.loaded = false;
        this.loadError = false;
        this.item = await this.requestNewsItem();
        this.loaded = true;
        await this.service.render();
    }

    private async requestNewsItem() {
        try {
            const { code, data } = await wiz.call("get", { id: this.post_id });
            if (code === 200 && data) return data;
            if (code === 404) return null;
            this.loadError = true;
        } catch {
            this.loadError = true;
        }
        return null;
    }

    public content() {
        if (!this.item) return '';
        const text = this.localize(this.item.content);
        return this.converter.makeHtml(text || '');
    }

    public itemTitle() {
        return this.localize(this.item?.title);
    }

    public itemDate() {
        const created = this.item?.created || '';
        if (created.length < 10) return created;
        return created.substring(0, 10).replace(/-/g, '.');
    }

    public categoryLabel() {
        const cat = this.categories.find(item => item.key === this.item?.category);
        return cat ? this.text(cat.label) : '';
    }

    public categoryIcon() {
        const cat = this.categories.find(item => item.key === this.item?.category);
        return cat ? cat.icon : 'icon-newspaper';
    }

    public downloadAttachments() {
        const rows = Array.isArray(this.item?.attachments) ? this.item.attachments : [];
        return rows.filter((asset: any) => asset?.url && asset.url !== this.item?.featured_image);
    }

    public text(value: LocalText) {
        if (!value) return '';
        const lang = this.currentLang;
        return value[lang] || value.en || value.ko || '';
    }

    public get currentLang(): 'ko' | 'en' {
        try {
            return this.service.lang.get() === 'ko' ? 'ko' : 'en';
        } catch {
            return 'en';
        }
    }

    private localize(value: any) {
        if (!value) return '';
        if (typeof value === 'string') return value;
        const lang = this.currentLang;
        return value[lang] || value.ko || value.en || '';
    }

    public back() {
        this.location.back();
    }
}

export default PageNewsItemComponent;